import { zodResolver } from '@hookform/resolvers/zod'
import { FC, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useLocation, useNavigate } from 'react-router-dom'
import { z } from 'zod'
import { serviceError } from '../../services/ajio'
import { FormInput, FormSelectInput } from './components'

import axios from 'axios'
import appStore from 'src/assets/product-config/app-store.png'
import background from 'src/assets/product-config/background-signin.png'
import android from 'src/assets/product-config/google-play.png'

import { ArrowLeft } from 'lucide-react'
import './styles.css'

const FormSchema = z.object({
  postalCode: z.string({
    required_error: 'Insira o seu CEP.',
  }),
  city: z.string({
    required_error: 'Insira sua Cidade.',
  }),
  state: z.string({
    required_error: 'Insira o seu Estado.',
  }),
  neighborhood: z.string({
    required_error: 'Insira seu Bairro.',
  }),
  address: z.string({
    required_error: 'Insira seu Endereço.',
  }),
  number: z.string({
    required_error: 'Insira o Número.',
  }),
  complement: z.string().optional(),
  type: z.string({
    required_error: 'Insira o tipo de Endereço',
  }),
})

type FormInputs = z.infer<typeof FormSchema>

export const InsertAccountAddress: FC = () => {
  const location = useLocation()

  const { accountType } = location.state

  const [loading, setLoading] = useState(false)

  const { control, handleSubmit, setError, setValue } = useForm<FormInputs>({
    resolver: zodResolver(FormSchema),
  })

  const navigate = useNavigate()

  async function handleAddress(data: FormInputs) {
    if (data?.state?.length !== 2) {
      setError('state', {
        message: 'Estado Inválido.',
      })
      return
    }

    if (
      !data.type ||
      (data.type != 'Residencial' && data.type != 'Comercial')
    ) {
      setError('type', { message: 'Escolha um tipo de endereço' })
      return
    }

    setLoading(true)
    try {
      localStorage.setItem('@yntech:signup-data-03', JSON.stringify(data))
      setLoading(false)
      if (accountType === 'PF') {
        navigate('/create-account-wallet/create-password', {
          state: { accountType },
        })
      } else {
        navigate('/create-account-wallet/insert-partner-data', {
          state: { accountType },
        })
      }
    } catch (err) {
      const myError = serviceError(err)
      setLoading(false)
    }
  }

  const handleSetAddress = async (cep: string) => {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)

      if (response.status === 200) {
        setValue('city', response.data.localidade)
        setValue('address', response.data.logradouro)
        setValue('neighborhood', response.data.bairro)
        setValue('state', response.data.uf)
      }
    } catch (error: unknown) {
      console.log(error)
    }
  }

  return (
    <div
      style={{
        backgroundImage: `url(${background})
`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
      }}
      className="w-full flex-col h-screen flex justify-center items-center gap-20 background"
    >
      <button
        onClick={() => navigate('/create-account-wallet/choose-account-type')}
        className="h-12 w-12 absolute left-10 top-10 flex items-center justify-center rounded-xl bg-zinc-950 shadow-sm"
      >
        <ArrowLeft size={22} color="white" />
      </button>
      <div className="flex flex-col absolute bottom-10 left-10">
        <span className="text-white text-xl font-bold">Baixe o nosso app,</span>
        <span className="text-white text-xl">
          disponível nas principais lojas
        </span>
        <div className="flex gap-2 mt-2">
          <img
            alt=""
            src={android}
            className="w-[150px] object-contain cursor-pointer"
          />
          <img
            alt=""
            src={appStore}
            className="w-[150px] object-contain cursor-pointer"
          />
        </div>
      </div>
      <div className="bg-black mr-10 self-end bg-opacity-40 rounded-3xl backdrop-filter backdrop-blur-md border border-gray-600 p-12 max-w-[50%] flex flex-col justify-center items-center">
        <div className="w-full h-full">
          <form onSubmit={handleSubmit(handleAddress)}>
            {fields.map((item: any, index: number) => {
              return (
                <div key={item.id}>
                  {item.isDropdown && (
                    <Controller
                      name={item.id as any}
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <span className="font-bold text-white">
                            {item.placeholder}
                          </span>
                          <FormSelectInput
                            placeholder={
                              field.value ? field.value : item.placeholder
                            }
                            style={{
                              height: '5.5vh',
                            }}
                            options={item!.options!}
                            {...field}
                            onChanged={(e) => field.onChange(e)}
                            error={fieldState.error?.message}
                          />
                        </>
                      )}
                    />
                  )}

                  {!item.isDropdown && item.breakPoint === false && (
                    <Controller
                      name={item.id as any}
                      control={control}
                      render={({ field, fieldState }) => (
                        <>
                          <span className="font-bold text-white">
                            {item.placeholder}
                          </span>
                          <FormInput
                            placeholder={item.placeholder}
                            required
                            style={{
                              height: '5.5vh',
                            }}
                            onBlur={(e) => {
                              handleSetAddress(e.target.value)
                            }}
                            value={field.value}
                            onChangeText={(e) => field.onChange(e)}
                            mask={item.mask}
                            errorMessage={fieldState.error?.message}
                          />
                        </>
                      )}
                    />
                  )}

                  {item.breakPoint && (
                    <div className="flex items-center gap-5 justify-between">
                      <Controller
                        name={item.id as any}
                        control={control}
                        render={({ field, fieldState }) => (
                          <div className="flex flex-col">
                            <span className="font-bold text-white">
                              {item.placeholder}
                            </span>
                            <FormInput
                              style={{
                                width: '16vw',
                                height: '5.5vh',
                              }}
                              onChangeText={(e) => field.onChange(e)}
                              placeholder={item.placeholder}
                              required
                              {...field}
                              mask={item.mask}
                              errorMessage={fieldState.error?.message}
                            />
                          </div>
                        )}
                      />
                      <Controller
                        name={fields[index + 1].id as any}
                        control={control}
                        render={({ field, fieldState }) => (
                          <div className="flex flex-col">
                            <span className="font-bold text-white">
                              {item.placeholder}
                            </span>
                            <FormInput
                              style={{
                                width: '16vw',
                                height: '5.5vh',
                              }}
                              placeholder={fields[index + 1].placeholder}
                              required
                              onChangeText={(e) => field.onChange(e)}
                              {...field}
                              mask={fields[index + 1].mask}
                              errorMessage={fieldState.error?.message}
                            />
                          </div>
                        )}
                      />
                    </div>
                  )}
                </div>
              )
            })}

            <div className="flex flex-col w-full gap-2 items-center justify-between mt-4">
              <button
                className="bg-white h-16 w-full border border-zinc-300 rounded-md font-bold"
                onClick={handleSubmit(handleAddress)}
              >
                Próximo
              </button>
              <button
                className="bg-zinc-900 h-16 w-full border border-zinc-300 rounded-md font-bold text-white"
                onClick={() => navigate('/create-account-wallet/choose-plan')}
              >
                Voltar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

const fields = [
  {
    id: 'postalCode',
    placeholder: 'CEP',
    breakPoint: false,
    mask: '99999-999',
  },
  {
    id: 'city',
    placeholder: 'Cidade',
    breakPoint: false,
  },
  {
    id: 'state',
    placeholder: 'Estado',
    breakPoint: true,
  },
  {
    id: 'neighborhood',
    placeholder: 'Bairro',
    breakPoint: undefined,
  },
  {
    id: 'address',
    placeholder: 'Endereço (Rua)',
    breakPoint: false,
  },
  {
    id: 'number',
    placeholder: 'Número',
    breakPoint: true,
  },
  {
    id: 'complement',
    placeholder: 'Complemento',
    breakPoint: undefined,
  },
  {
    id: 'type',
    placeholder: 'Tipo de endereço',
    isDropdown: true,
    options: ['Residencial', 'Comercial'],
    breakPoint: false,
  },
]
